import React from "react";

import {useMap} from "react-leaflet";


// import {useMap} from 'react-use'

export default function ChangeView({ center, zoom }) {
    const map = useMap();
    map.setView(center, zoom);
    return null;

}